<template>
  <v-list data-cy="table-actions-button-actions-list" density="compact">
    <v-list-item v-if="noEnabledActions" class="label">{{
      $t('common.noActions')
    }}</v-list-item>

    <template v-for="(action, index) in config" :key="action.id">
      <v-list-item
        v-if="isAction(action)"
        v-show="isVisible(action)"
        :disabled="action.disabled ? action.disabled() : false"
        :data-cy="'table-actions-button-' + action.title.split('.').join('-')"
        :prepend-icon="action.icon"
        @click="
          action.callback(item);
          captureAnalytics(action);
        "
      >
        {{ $t(action.title, action.translateCount ?? 1) }}
      </v-list-item>
      <v-divider v-else-if="hasVisiblePrecedingAction(index)" class="my-2" />
    </template>
  </v-list>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ActionsButtonWithCallback } from '../../types/DataTable';
import { ButtonCallbacks } from '@/components/types/DataTable';
import {
  captureActionButtonAction,
  captureDetailsActionButtonAction
} from '@/util/posthog';

export default defineComponent({
  name: 'ActionButtonList',
  props: {
    config: {
      type: Array as () => ActionsButtonWithCallback[],
      required: true
    },
    item: {
      type: Object as () => Record<string, unknown>,
      required: false,
      default: () => ({})
    },
    posthogActionData: {
      type: Object as () => Record<string, unknown>,
      default: null
    }
  },
  computed: {
    noEnabledActions(): boolean {
      return this.config.every((action) => !this.isVisible(action));
    }
  },
  methods: {
    isAction(action: ActionsButtonWithCallback): boolean {
      return action.id !== ButtonCallbacks.NONE;
    },
    isVisible(action: ActionsButtonWithCallback): boolean {
      const isHidden = action.hidden ? action.hidden(this.item) : false;
      return !isHidden;
    },
    hasVisiblePrecedingAction(index: number): boolean {
      const previous = this.config
        .slice(0, index)
        .findLast((entry) => !this.isAction(entry) || this.isVisible(entry));
      return !!previous && this.isAction(previous);
    },
    captureAnalytics(action: ActionsButtonWithCallback) {
      if (this.posthogActionData) {
        captureActionButtonAction(
          this.posthogActionData.dataTableId as string,
          ButtonCallbacks[action.id],
          this.posthogActionData.numSelectedElements as number
        );
      } else if (this.$attrs['capture-page-action']) {
        captureDetailsActionButtonAction(
          ButtonCallbacks[action.id],
          this.$router.currentRoute.value.name as string
        );
      } else {
        // Nothing to capture
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.v-list-item--disabled {
  opacity: 0.4;
}
.v-menu__content {
  box-shadow: 0 0.1 0 0.1 !important;
}
</style>
